import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";

import { Root } from "./Root.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
